export function upperSnakeCaseToLowerCase(string) {
  const arr = string.split('_');
  const capitalize = (string) => {
    const lower = string.toLowerCase();
    const firstLetter = lower.slice(0, 1).toUpperCase();
    const rest = lower.slice(1);
    return firstLetter + rest;
  };

  const newArr = arr.map((word) => capitalize(word));
  return newArr.join(' ');
}
